import { type FC } from 'react';

import { Box, Flex } from '@myphx-engineering/phx-design-system';
import {
    INSURANCE_OFFER_PRIORITY,
    SELF_PAY_OFFER_PRIORITY,
    isInsuranceOfferType,
    isSelfPayOfferType,
} from '@phx/data-sources/medication-marketplace';

import { useFillPrescription } from '../../../../contexts/fill/use-fill-prescription';
import { getBestOffer } from '../../../../hooks/use-prescription-offers';

import { SelectInsurancePathCard } from './SelectInsurancePathCard';
import { SelectSelfPayPathCard } from './SelectSelfPayPathCard';

export const InsurancePathSelectionCards: FC = () => {
    const { allOffers } = useFillPrescription();

    const selfPayOffers = allOffers.filter((offer) =>
        isSelfPayOfferType(offer.headlinePriceType)
    );
    const insuranceOffers = allOffers.filter((offer) =>
        isInsuranceOfferType(offer.headlinePriceType)
    );

    const bestSelfPayOffer = getBestOffer(
        selfPayOffers,
        SELF_PAY_OFFER_PRIORITY
    );
    const bestInsuranceOffer = getBestOffer(
        insuranceOffers,
        INSURANCE_OFFER_PRIORITY
    );

    return (
        <Flex gap="xs">
            <Box flex={1}>
                <SelectInsurancePathCard offer={bestInsuranceOffer} />
            </Box>
            <Box flex={1}>
                <SelectSelfPayPathCard offer={bestSelfPayOffer} />
            </Box>
        </Flex>
    );
};
